import * as assert from 'assert';
import { ApiService } from './ApiService';

export abstract class AbstractCRUDService<T, C, U> extends ApiService {

    public create(newRecord: C): Promise<void> {
        return this.postRequest(newRecord)
            .then(response => {
                return;
            });
    }

    public getAll(): Promise<T[]> {
        return this.getRequest()
            .then((response: any[]) => {
                if (Array.isArray(response)) {
                    return this.assembleInstances(response);
                } else {
                    assert(false, 'AbstractCRUDService - getAll : unexpected response from server');
                }

                return [] as T[];
            });
    }

    public getById(id: number | string): Promise<T> {
        return this.getSubPath(id.toString())
            .then((response: object) => {
                return this.assembleSingleInstance(response);
            });
    }

    public updateById(id: number | string, updatedRecord: U): Promise<void> {
        assert(null != updatedRecord, 'updatedRecord was undefined');
        return this.putSubPath(id.toString(), updatedRecord)
            .then(response => {
                return;
            });
    }

    public deleteById(id: number | string): Promise<void> {
        return this.deleteSubPath(id.toString())
            .then(response => {
                return;
            });
    }

    protected abstract assembleInstances(response: any[]): T[];

    protected abstract assembleSingleInstance(response: any): T;

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data_layer/services/AbstractCRUDService.ts